// extracted by mini-css-extract-plugin
export default {"searchBox":"SearchInput_searchBox__jS6qp","searchIcon":"SearchInput_searchIcon__4fhAP","searchInput":"SearchInput_searchInput__Rpr4h"};